<template>
  <div id="app">
      <img :src="logo" class="logo" alt="Janimo" title="Janimo"/>
      
      <p>
        De website is nog in ontwikkeling. <br>Neemt u alstublieft contact met mij op via onderstaande opties. <br><br>
        <a class="link" href="mailto:jan@janimo.nl">E-mail</a>
        <a class="link" href="tel:0610835568">Bellen</a>
      </p>
  </div>
</template>

<script>
/* eslint-disable */
import logo from './assets/images/logo/logo.jpg';
export default {
  data: function() {
    return {
      logo
    };
  }
}
</script>

<style lang="scss">
$blue: #01638b;
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
  p {
    font-family: Calibri;
    color: $blue;
  }
  .logo {
      position: relative;
      padding-top: 100px;
      padding-bottom: 100px;
      width: 250px;
      height: auto;
      margin: 0 auto;
  }

  .link {
    font-family: Calibri, Arial, Helvetica, sans-serif;
    font-size: 24px;
    font-weight: bold;
    position: relative;
    margin: 0 auto;
    text-decoration: none;
    color: $blue;
    margin: 20px 20px;
    padding: 10px 10px;
    border: 1px solid $blue;
    border-radius: 5px;
  }
  .link:active {
    border: 3px solid $blue;
  }

</style>
